import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';

import BasicDialog from './BasicDialog';

type Props = {
  name?: string;
  phone?: string;
};

const BasicCard = ({ name, phone }: Props) => {
  return (
    <Card className="mb-4">
      <CardHeader className="sm:flex-row sm:justify-between sm:items-center gap-4">
        <div className="grow">
          <CardTitle className="text-lg mb-1">Basic information</CardTitle>
          <CardDescription>Your personal details and account information.</CardDescription>
        </div>
        <BasicDialog name={name} phone={phone} />
      </CardHeader>
      <CardContent>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className="font-semibold w-[190px]">Full name</TableCell>
              <TableCell className="w-[85px]">:</TableCell>
              <TableCell>{name || '-'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="font-semibold w-[190px]">Phone number</TableCell>
              <TableCell className="w-[85px]">:</TableCell>
              <TableCell>{phone || '-'}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default BasicCard;
